import React from 'react'

export type FloorsIconProps = {
  size?: number
  color?: string
  className?: string
}

export const FloorsIcon = ({
  size = 20,
  color = 'currentColor',
  className,
}: FloorsIconProps) => (
  <svg
    aria-label='Floors'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M22 7.999a1 1 0 0 0-.516-.874l-9.022-5a1.003 1.003 0 0 0-.968 0l-8.978 4.96a1 1 0 0 0-.003 1.748l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5A1 1 0 0 0 22 7.999zm-9.977 3.855L5.06 7.965l6.917-3.822 6.964 3.859-6.918 3.852z'
      fill={color}
    />
    <path
      d='M20.515 11.126 12 15.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748z'
      fill={color}
    />
    <path
      d='M20.515 15.126 12 19.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748z'
      fill={color}
    />
  </svg>
)
